import { States } from "./states.constants";
import { Countries } from "./countries.constants";
import { Messages } from "./messages.constants";
import { General } from "./general.constant";


export class AppSettings {
    static general = General;
    static states = States;
    static countries = Countries;
    static messages = Messages;
}
